<script>
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let disabled = false;
	export let id = '';
	export let active = false;
	export let imageUrl = 'https://loremflickr.com/640/360';
	export let activeImageUrl = imageUrl;
	export let imageHeight = '72';
	export let imageWidth = '72';

	const handleClick = () => {
		dispatch('click');
	};
</script>

<button id={id} class="round-button {active === true ? 'active' : ''}" class:active {disabled}on:click={handleClick}>
    <img src={active === true ? activeImageUrl : imageUrl} alt="{imageUrl}" height={imageHeight} width={imageWidth}/>
</button>

<style>
	.round-button {
		width: 130px;
		height: 130px;
		line-height: 80px;
		border: 12px solid #e6e6e6;
		border-radius: 50%;
		text-align: center;
		text-decoration: none;
		background: #f4f4f4;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
		margin: 0 10px 10px 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.round-button.active {
		border-color:  var(--blue);
		background-color: var(--sidebar-icon-color);
	}

	button:disabled,
	button[disabled]{
		opacity: 0.5;
		cursor: not-allowed;
	}

	@media(max-width:1600px){
		.round-button{
			width: 110px;
			height: 110px;
			border: 10px solid #e6e6e6;
		}

		.round-button img{
			width: 60px;
			height: 60px;
		}
	}

	@media(max-width:1200px){
		.round-button{
			width: 80px;
			height: 80px;
		}

		.round-button img{
			width: 40px;
			height: 40px;
		}
	}
</style>
